import { LoadingButtonProps } from '@mui/lab';
import { Grid } from '@mui/material';
import { PropsWithChildren } from 'react';
import { ActionButton } from '../../reusable/action-button';

type PropTypes = PropsWithChildren<{
  primary: Partial<LoadingButtonProps>;
  secondary?: Partial<LoadingButtonProps>;
}>;

export const AssessmentButtons = ({
  primary,
  secondary,
  children,
}: PropTypes) => (
  <Grid container spacing={1} direction="row" sx={{ mt: 1 }}>
    <Grid item xs={12} sm="auto">
      <ActionButton {...primary} />
    </Grid>
    {secondary && (
      <Grid item xs={12} sm="auto">
        <ActionButton secondary {...secondary} />
      </Grid>
    )}
    {children && (
      <Grid item xs={12} sm="auto">
        {children}
      </Grid>
    )}
  </Grid>
);
